import { render, staticRenderFns } from "./ControlPointsList.vue?vue&type=template&id=283c67ce&"
import script from "./ControlPointsList.vue?vue&type=script&lang=js&"
export * from "./ControlPointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports